import { BaseService } from './../../../core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-sales-order-invoice-lines-dialog',
  templateUrl: './sales-order-invoice-lines-dialog.component.html',
  styleUrls: ['./sales-order-invoice-lines-dialog.component.scss']
})
export class SalesOrderInvoiceLinesDialogComponent implements OnInit {
  lines = [];

  selectedLines = [];

  constructor(
    private dialogRef: MatDialogRef<SalesOrderInvoiceLinesDialogComponent>,
    private dialog: MatDialog,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.lines = (this.data.lines || []).filter(f => f.shipQty > 0);

  }

  createInvoice() {

    const dialogData: OiGroupDialogData = {
      title: 'Creating Invoice',
      function: 'portal_oi_group_sales_order_create_invoice',
      postBody: {
        salesOrderNumber: this.data.erpSalesOrderNumber,
        // allocateDepositToInvoice: true,
        lines: this.selectedLines,
        linesString: this.selectedLines.join(','),
      }
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
        this.dialogRef.close(true);
      }
    });
  }


}
